<template>
  <div class="gif-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('gif_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-toilet</v-icon>Gifs</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <GifFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />
          <v-container grid-list-xl fluid>
            <v-row>
              <v-col cols="12" sm="3" md="3" v-for="item in items" :key="item.id" >
                <v-card class="secondary">
                  <v-img
                    height="250"
                    class="white--text align-end grey darken-4"
                    lazy-src="@/assets/imagenotfound.png"
                    :key="componentKey"
                    contain
                    @click="showHandler(item)"
                    :src="getImageUrlByObject(item)"
                  >

                   </v-img>

                   <v-card-actions>
                     <v-card-title v-text="item.name"></v-card-title>
                     <v-spacer></v-spacer>
                     <v-btn v-if="item" icon @click="downloadImageList(item['id'],item['@entity'],item['image'].filePath)">
                       <v-icon>mdi-download</v-icon>
                     </v-btn>
                   </v-card-actions>
                 </v-card>
              </v-col>
            </v-row>
          </v-container>

        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import GifFilterForm from '../../components/gif/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';
import FileMixin from '../../mixins/FileMixin';

export default {
  name: 'GifList',
  servicePrefix: 'Gif',
  mixins: [ListMixin,AccessMixin,FileMixin],
  components: {
    Toolbar,
    GifFilterForm,
    DataFilter
  },
  data() {
    return {
    //  filter: '250x250',

      options: {sortBy : ['name'], sortDesc : [false]}
    };
  },
  mounted() {
      this.getPage({'itemsPerPage': '100','order[id]': 'desc'})
  },
  computed: {
    ...mapGetters('gif', {
      items: 'list'
    }),
    ...mapFields('gif', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('gif', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
